<template>
  <div class="addCameraManagement-page">
    <div class="all-content-container">
      <div class="table-content-container">
        <div class="table-title-container">
          <div class="table-title-title">
            <div class="title-back">
              <h4>添加传感器</h4>
              <p class="backBth" @click="canlan">
                <i class="el-icon-caret-left"></i>
                <span>返回</span>
              </p>
            </div>
          </div>
        </div>
        <div class="table-content">
          <el-form
            label-position="right"
            label-width="120px"
            :model="dialogform"
            :rules="rules"
            ref="dialogform"
          >
            <!-- <el-form-item label="设备图片：" style="height: 88px">
              <el-form
                :inline="true"
                class="demo-form-inline demo-ruleForm"
                style="margin-left: 10px"
              >
                <el-form-item>
                  <el-upload
                    class="avatar-uploader"
                    :action="$serverUrl + '/pc/growthCrop/uploadImage'"
                    :headers="headers"
                    name="file"
                    :limit="10"
                    :on-exceed="handleExceed"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :on-progress="handleAvatarProgress"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img
                      v-if="show"
                      :src="dialogform.imageURL"
                      class="avatar"
                    />
                    <div class="image1" v-if="!show">
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                  </el-upload>
                  <p class="isLine">在线</p>
                </el-form-item>
                <el-form-item>
                  <el-upload
                    class="avatar-uploader"
                    :action="$serverUrl + '/pc/growthCrop/uploadImage'"
                    :headers="headers"
                    name="file"
                    :limit="10"
                    :on-exceed="handleExceed0"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess0"
                    :on-progress="handleAvatarProgress0"
                    :before-upload="beforeAvatarUpload0"
                  >
                    <img
                      v-if="show0"
                      :src="dialogform.imageURL0"
                      class="avatar"
                    />
                    <div class="image1" v-if="!show0">
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                    </div>

                  </el-upload>
                  <p class="isLine">离线</p>
                </el-form-item>
                <el-form-item>
                  <el-upload
                    class="avatar-uploader"
                    :action="$serverUrl + '/pc/growthCrop/uploadImage'"
                    :headers="headers"
                    name="file"
                    :limit="10"
                    :on-exceed="handleExceed1"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess1"
                    :on-progress="handleAvatarProgress1"
                    :before-upload="beforeAvatarUpload1"
                  >
                    <img
                      v-if="show1"
                      :src="dialogform.imageURL1"
                      class="avatar"
                    />
                    <div class="image1" v-if="!show1">
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                  </el-upload>
                  <p class="isLine">告警</p>
                </el-form-item>
              </el-form>
            </el-form-item> -->

            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="设备名称："
                  prop="name"
                  style="margin-top: 80px"
                >
                  <el-input
                    v-model="dialogform.name"
                    placeholder="请输入设备名称"
                    maxlength="20"
                    clearable
                    class="inputW"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="设备编码："
                  prop="code"
                  style="margin-top: 80px"
                >
                  <el-input
                    v-model="dialogform.code"
                    placeholder="请输入设备编码"
                    maxlength="20"
                    clearable
                    class="inputW"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item label="参数类型：" prop="paramType">
                    <el-select
                      v-model="dialogform.paramType"
                      placeholder="请选择参数类型"
                      class="inputW"
                    >
                      <el-option
                        v-for="item in paramTypeList"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="地址位：">
                    <el-input
                      v-model="dialogform.addressBit"
                      :controls="false"
                      placeholder="请输入地址位"
                      maxlength="20"
                      clearable
                      class="inputW"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item label="所属分组：" prop="groupId">
                    <el-cascader
                      class="inputW"
                      @change="changeTreeItem"
                      :show-all-levels="false"
                      v-model="dialogform.groupId"
                      :options="departList"
                      :props="optionProps"
                      clearable
                      placeholder="请选择所属分组"
                    ></el-cascader>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="所属网关：" prop="gatewayId">
                    <el-select
                      v-model="dialogform.gatewayId"
                      placeholder="请选择所属网关"
                      class="inputW"
                    >
                      <el-option
                        v-for="item in getGatewaysList"
                        :key="item.value"
                        :label="item.gatewayName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item label="模板类型：" prop="modelRuleDeviceId">
                    <el-select
                      v-model="dialogform.modelRuleDeviceId"
                      placeholder="请选择模板类型"
                      class="inputW"
                    >
                      <el-option
                        v-for="item in modelRuleDeviceIdList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="协议类型：" prop="protocolType">
                    <el-select
                      v-model="dialogform.protocolType"
                      placeholder="请选择协议类型"
                      class="inputW"
                    >
                      <el-option
                        v-for="item in htppTypeList"
                        :key="item.id"
                        :label="item.type"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item label="采集时间间隔：" prop="intervalTime">
                    <el-input-number
                      placeholder="请输入采集数据间隔(秒)"
                      v-model="dialogform.intervalTime"
                      :precision="0"
                      :step="1"
                      :min="0"
                      :max="99999999"
                      size="small"
                      clearable
                      class="inputW"
                    ></el-input-number>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="采集超时时间：" prop="collectTimeout">
                    <el-input-number
                      placeholder="请输入采集超时间隔(毫秒)"
                      v-model="dialogform.collectTimeout"
                      :precision="0"
                      :step="1"
                      :min="0"
                      :max="99999999"
                      size="small"
                      clearable
                      class="inputW"
                    ></el-input-number>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="grid-content bg-purple-dark">
                  <el-form-item label="生产日期：" prop="pdate">
                    <el-date-picker
                      class="inputW iconWz"
                      v-model="dialogform.pdate"
                      align="right"
                      type="date"
                      placeholder="请选择生产日期"
                      :picker-options="pickerOptions"
                    ></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item label="定位类型：" prop="locationType">
                    <el-select
                      v-model="dialogform.locationType"
                      placeholder="请选择定位类型"
                      class="inputW"
                    >
                      <el-option label="地图定位" value="0"></el-option>
                      <el-option label="采集定位" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="经度："
                    placeholder="请输入经度"
                    prop="longitude"
                  >
                    <el-input-number
                      placeholder="请输入经度"
                      v-model="dialogform.longitude"
                      :precision="6"
                      :step="1"
                      :min="-99999999"
                      :max="99999999"
                      size="small"
                      clearable
                      class="inputW"
                      :disabled="dialogform.locationType == 1"
                    ></el-input-number>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="纬度：">
                    <el-input-number
                      placeholder="请输入纬度"
                      v-model="dialogform.dimension"
                      :precision="6"
                      :step="1"
                      :min="-99999999"
                      :max="99999999"
                      size="small"
                      clearable
                      class="inputW"
                      :disabled="dialogform.locationType == 1"
                    ></el-input-number>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-form-item style="margin-left: 120px">
              <el-button @click="canlan">取 消</el-button>
              <el-button type="primary" @click="submitForm('dialogform')"
                >确 定</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      departList: [],
      getGatewaysList: [],
      departLis: [],
      id: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      rules: {
        // 弹框表单验证
        name: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入设备编码", trigger: "blur" }],
        paramType: [
          { required: true, message: "请选择参数类型", trigger: "change" },
        ],
        groupId: [
          { required: true, message: "请选择所属分组", trigger: "change" },
        ],
        gatewayId: [
          { required: true, message: "请选择所属网关", trigger: "change" },
        ],
        modelRuleDeviceId: [
          { required: true, message: "请选择模板类型", trigger: "change" },
        ],
        protocolType: [
          { required: true, message: "请选择协议类型", trigger: "change" },
        ],
        intervalTime: [
          { required: true, message: "请输入采集时间间隔", trigger: "blur" },
          {
            pattern: /^[0-9]*$/, //正则
            message: "请输入正确的采集时间间隔",
          },
        ],
        collectTimeout: [
          { required: true, message: "请输入采集超时时间", trigger: "blur" },
          {
            pattern: /^[0-9]*$/, //正则
            message: "请输入正确的采集超时时间",
          },
        ],
        pdate: [
          { required: true, message: "请选择生产日期", trigger: "change" },
        ],
        locationType: [
          { required: true, message: "请选择定位类型", trigger: "change" },
        ],
      },
      modelRuleDeviceIdList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        expandTrigger: "hover",
      },
      show: false,
      show0: false,
      show1: false,
      headers: {
        // 身份验证
        AUTHORIZATION: sessionStorage.getItem("TOKEN"),
      },
      //协议类型(0：mqtt，1：coap,2：ModbusTCP，3：ModbusRTU，4：TCP, 5：BACNET，6：SNMP，7：OPC）
      htppTypeList: [
        {
          id: 0,
          type: "mqtt",
        },
        {
          id: 1,
          type: "coap",
        },
        {
          id: 2,
          type: "ModbusTCP",
        },
        {
          id: 3,
          type: "ModbusRTU",
        },
        {
          id: 4,
          type: "TCP",
        },
        {
          id: 5,
          type: "BACNET",
        },
        {
          id: 6,
          type: "SNMP",
        },
        {
          id: 7,
          type: "OPC",
        },
      ],
      paramTypeList: [
        //（0环境参数，1作物参数，2土壤参数）
        {
          id: "0",
          label: "环境参数",
        },
        {
          id: "1",
          label: "作物参数",
        },
        {
          id: "2",
          label: "土壤参数",
        },
      ],

      options: [
        {
          value: 1,
          label: "传感树001",
        },
        {
          value: "2",
          label: "传感树002",
        },
        {
          value: "3",
          label: "传感树004",
        },
        {
          value: "4",
          label: "传感树004",
        },
        {
          value: "5",
          label: "传感树005",
        },
      ],

      name: "",
      id: "",
      dialogform: {
        region: "",
        code: "",
        address: "",
        group: "",
        template: "",
        name: "",
        groupId: "",
        gateway: "",
        gatewayId: "",
        manufacture: "",
        agreement: "",
        interval: "",
        intervalTime: "",
        overtime: "",
        dimension: undefined,
        geographical: "",
        longitude: undefined,
        pdate: "",
        locationType: "",
        imageURL: "",
        imageURL0: "",
        imageURL1: "",
        protocolType: "",
        modelRuleDeviceId: "",
        collectTimeout: "",
        paramType: "",
        addressBit: "",
        dialogform1: {
          modelRuleDeviceId: "",
          paramType: "",
        },
      },
    };
  },
  created() {
    this.getGateways();
    this.id = this.$route.query.id; // 编辑id
    this.getConfigGroupTree();
    this.getModelRuleDevices();
    this.getNumerical(this.$route.query.id);
  },
  methods: {
    canlan() {
      this.$router.push({
        name: "deviceManagement",
        query: {
          currentShow: "second",
          currentShow1: "first",
        },
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onsumit();
        } else {
          return false;
        }
      });
    },
    changeTreeItem(val) {
      this.dialogform.groupId = val[val.length - 1];
    },
    // 提交
    onsumit() {
      this.saveNumerical();
    },
    zhDatetime(t) {
      if (t == "" || t == null || t == undefined) {
        return "";
      } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : "0" + M;
        D = D > 9 ? D : "0" + D;
        h = h > 9 ? h : "0" + h;
        m = m > 9 ? m : "0" + m;
        s = s > 9 ? s : "0" + s;
        return Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;
      }
    },
    // 保存，编辑 传感器
    saveNumerical() {
      var timer = this.zhDatetime(this.dialogform.pdate);
      if (this.id != "" || this.id != undefined) {
        let paramType = "";
        if (this.dialogform.paramType == "环境参数") {
          paramType = 0;
        } else if (this.dialogform.paramType == "作物参数") {
          paramType = 1;
        } else if (this.dialogform.paramType == "土壤参数") {
          paramType = 2;
        } else {
          paramType = this.dialogform.paramType;
        }
        this.dialogform.paramType = paramType;
      }
      if (this.id == undefined) {
        this.id = "";
      }
      let data = new FormData();
      data.append("code", this.dialogform.code);
      data.append("gatewayId", this.dialogform.gatewayId);
      data.append("name", this.dialogform.name);
      data.append("image1", this.dialogform.imageURL);
      data.append("image2", this.dialogform.imageURL0);
      data.append("image3", this.dialogform.imageURL1);
      data.append("addressBit", this.dialogform.addressBit);
      data.append("collectTimeout", this.dialogform.collectTimeout);
      if (this.dialogform.dimension != null) {
        data.append("dimension", this.dialogform.dimension);
      }
      data.append("groupId", this.dialogform.groupId);
      data.append("intervalTime", this.dialogform.intervalTime);
      if (this.dialogform.longitude != null) {
        data.append("longitude", this.dialogform.longitude);
      }
      data.append("modelRuleDeviceId", this.dialogform.modelRuleDeviceId);
      data.append("paramType", this.dialogform.paramType);
      data.append("pdate", timer);
      data.append("protocolType", this.dialogform.protocolType);
      data.append("id", this.id);
      data.append("locationType", this.dialogform.locationType);

      this.$api.system
        .saveNumerical(data)
        .then((res) => {
          if (res.code == 200) {
            this.$router.push({
              name: "deviceManagement",
              query: {
                currentShow: "second",
                currentShow1: "first",
              },
            });
            this.$message({
              type: "success",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传10张图片`);
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.srcList = [];
        this.show = true;
        this.$forceUpdate();
        this.dialogform.imageURL = res.data;
        this.$toaster.ok(res.msg);
        this.imgUpdateProgress = 100;
        setTimeout(() => {
          this.isUpdateSuccess = false;
          this.imgUpdateProgress = 0;
        }, 200);
      }
    },
    handleAvatarProgress(event, file, fileList) {
      // 文件上传时的进度
      this.isUpdateSuccess = true;
      var timer = setInterval(() => {
        this.imgUpdateProgress += 10;
        if (this.imgUpdateProgress >= 90) {
          clearInterval(timer);
        }
      }, 200);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isSize = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 、PNG 格式!");
      }
      if (!isSize) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isSize;
    },

    handleExceed0(files, fileList) {
      this.$message.warning(`最多上传10张图片`);
    },
    handleAvatarSuccess0(res, file) {
      if (res.code == 200) {
        this.srcList = [];
        this.show0 = true;
        this.$forceUpdate();
        this.dialogform.imageURL0 = res.data;
        this.$toaster.ok(res.msg);

        this.imgUpdateProgress = 100;
        setTimeout(() => {
          this.isUpdateSuccess = false;
          this.imgUpdateProgress = 0;
        }, 200);
      }
    },
    handleAvatarProgress0(event, file, fileList) {
      // 文件上传时的进度
      this.isUpdateSuccess = true;
      var timer = setInterval(() => {
        this.imgUpdateProgress += 10;
        if (this.imgUpdateProgress >= 90) {
          clearInterval(timer);
        }
      }, 200);
    },
    beforeAvatarUpload0(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isSize = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 、PNG 格式!");
      }
      if (!isSize) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isSize;
    },
    handleExceed1(files, fileList) {
      this.$message.warning(`最多上传10张图片`);
    },
    handleAvatarSuccess1(res, file) {
      // console.log( res, file );
      if (res.code == 200) {
        this.srcList = [];
        this.show1 = true;
        this.$forceUpdate();
        this.dialogform.imageURL1 = res.data;
        this.$toaster.ok(res.msg);

        this.imgUpdateProgress = 100;
        setTimeout(() => {
          this.isUpdateSuccess = false;
          this.imgUpdateProgress = 0;
        }, 200);
      }
    },
    handleAvatarProgress1(event, file, fileList) {
      // 文件上传时的进度
      this.isUpdateSuccess = true;
      var timer = setInterval(() => {
        this.imgUpdateProgress += 10;
        if (this.imgUpdateProgress >= 90) {
          clearInterval(timer);
        }
      }, 200);
    },
    beforeAvatarUpload1(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isSize = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 、PNG 格式!");
      }
      if (!isSize) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isSize;
    },
    //查询设备分组树，查询1
    getConfigGroupTree() {
      this.$api.system
        .getConfigGroupTree(
          0, //主键id ，根据具体业务进行判定
          1, //第几页，默认1
          999 //默认展示多少条，默认10
        )
        .then((res) => {
          if (res.code == 200) {
            this.departList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //查询全部设备类型模板
    getModelRuleDevices() {
      this.$api.system
        .getModelRuleDevices(0)
        .then((res) => {
          if (res.code == 200) {
            this.modelRuleDeviceIdList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 编辑时查询传感器详情
    getNumerical(id) {
      if (id == undefined) {
        return false;
      }
      this.$api.system
        .getNumerical(
          id //编辑id
        )
        .then((res) => {
          if (res.code == 200) {
            this.show = true;
            this.show0 = true;
            this.show1 = true;
            this.dialogform.code = res.data.code;
            this.dialogform.gatewayId = res.data.gatewayId;
            this.dialogform.name = res.data.name;
            this.dialogform.imageURL = res.data.image1;
            this.dialogform.imageURL0 = res.data.image2;
            this.dialogform.imageURL1 = res.data.image3;
            this.dialogform.addressBit = res.data.addressBit;
            this.dialogform.collectTimeout = res.data.collectTimeout;
            this.dialogform.dimension = res.data.dimension;
            this.dialogform.groupId = res.data.groupId;
            this.dialogform.intervalTime = res.data.intervalTime;
            this.dialogform.longitude = res.data.longitude;
            this.dialogform.modelRuleDeviceId = res.data.modelRuleDeviceId;
            var paramType = "";
            if (res.data.paramType == 0) {
              paramType = "环境参数";
            } else if (res.data.paramType == 1) {
              paramType = "作物参数";
            } else {
              paramType = "土壤参数";
            }

            this.dialogform.paramType = paramType;
            this.dialogform.pdate = res.data.updateTime;
            this.dialogform.protocolType = res.data.protocolType;
            this.dialogform.locationType = res.data.locationType.toString();
            this.dialogform.id = res.data.id;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //查询全部通信网关
    getGateways() {
      this.$api.system
        .getGateways()
        .then((res) => {
          if (res.code == 200) {
            this.getGatewaysList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/addCameraManagement.scss";
.addCameraManagement-page {
  height: calc(100vh - 120px) !important;
}
img {
  display: inline-block;
  height: 100px;
  width: 100px;
  margin-right: 30px;
}
.image1 {
  margin-right: 30px;
  margin-left: 15px;
  height: 100px;
  width: 100px;
  border: 1px solid #ededed;
}
.avatar-uploader-icon {
  margin-top: 40px;
}
li {
  padding-left: 15px;
}

.isLine {
  text-align: center;
}
.inputW {
  width: 230px !important;
}
</style>